import { cx } from "class-variance-authority";
import React, { FC, HTMLAttributes } from "react";
import classnames from "classnames";
import useDarkMode from "@/hooks/useDarkMode";
import logoDark from "@/assets/img/brand/logo_dark.png";
import logoLight from "@/assets/img/brand/logo_light.png";
interface AppLogoProps extends HTMLAttributes<HTMLDivElement> {
  mode?: "dark" | "light";
  size?: "sm" | "base" | "lg" | "xl" | "xxl";
  text?: string;
}

const AppLogo: FC<AppLogoProps> = ({
  className,
  size = "lg",
  mode: controlledMode,
  text,
}) => {
  const { isDarkMode } = useDarkMode();
  let mode = controlledMode ?? (isDarkMode ? "light" : "dark");

  return (
    <div className={cx("flex flex-row items-center", className)}>
      {text ? (
        <>
          <img
            alt="Keep Logo"
            className={classnames("hidden print:block", {
              "max-h-14": size === "lg",
              "max-h-10": size === "base",
              "max-h-8": size === "sm",
            })}
            src={logoLight}
          />
          <img
            alt="Keep Logo"
            className={classnames("block print:hidden", {
              "max-h-14": size === "lg",
              "max-h-10": size === "base",
              "max-h-8": size === "sm",
            })}
            src={mode === "light" ? logoDark : logoLight}
          />
          <div
            className={classnames(
              "font-semibold tracking-widest print:text-gray-900",
              {
                "text-white": mode === "light",
                "text-gray-900": mode === "dark",
              },
              {
                "text-4xl": size === "lg",
                "text-2xl": size === "base",
                "text-lg": size === "sm",
              }
            )}
          >
            {text}
          </div>
        </>
      ) : (
        <div
          className={classnames(
            "mb-[2px] font-semibold tracking-widest print:text-gray-900",
            {
              "text-white": mode === "light",
              "text-gray-900": mode === "dark",
            },
            {
              "text-8xl": size === "xxl",
              "text-6xl": size === "xl",
              "text-4xl": size === "lg",
              "text-2xl": size === "base",
              "text-lg": size === "sm",
            }
          )}
        >
          INTR
          <img
            alt="Keep Logo"
            className={classnames(
              "-mx-2 mb-1 inline-flex items-center print:hidden",
              {
                "-mx-4 mb-3": size === "xl",
                "-mx-2 mb-1": size !== "xl",
                // "max-h-24": size === "xxl",
                "max-h-24": size === "xl",
                "max-h-14": size === "lg",
                "max-h-9": size === "base",
                "max-h-8": size === "sm",
              }
            )}
            src={mode === "light" ? logoDark : logoLight}
          />
          SYS
        </div>
      )}
    </div>
  );
};

export default AppLogo;
